import B, { getUtils, getRefs } from '@js/components/_common/_Base'



/* BASE COMPONENT
---------------------------------------------------------------------------------------------------- */

export default class BaseComponent extends B {

    constructor(name, $el, namespace) {
        super(namespace)

        this.name = name
        this.namespace = namespace

        this.$el = $el
        this.$utils = getUtils()
        this.$refs = getRefs(this.$el, this.name)

        this.bindProperties()
        this.bindHandlers()
        this.bindEvents()
    }


    bindProperties() {
        //
    }

    bindHandlers() {
        //
    }

    bindEvents() {
        //
    }

}





/* CONSTANTS & HELPERS
---------------------------------------------------------------------------------------------------- */



